import React, { createContext, useContext } from 'react';
import { isPreviewPrice } from './isPreviewPrice';

type AppMode = 'DEFAULT' | 'PREVIEW';

interface PricingContextValue {
  appMode: AppMode;
  isPreview: boolean;
}

const PricingContext = createContext<PricingContextValue>({
  appMode: 'DEFAULT',
  isPreview: false,
});

interface PricingContextProviderProp {
  appMode: AppMode;
}

const PricingContextProvider: React.FC<
  React.PropsWithChildren<PricingContextProviderProp>
> = ({ appMode, children }) => {
  return (
    <PricingContext.Provider
      value={{
        appMode,
        isPreview: isPreviewPrice(appMode),
      }}
    >
      {children}
    </PricingContext.Provider>
  );
};

const usePricingContext = () => useContext(PricingContext);

export { PricingContextProvider, type AppMode, usePricingContext };
